// components/ChangePinModal.js

import React, { useState } from 'react';
import Swal from 'sweetalert2';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';

const ChangePinModal = ({ show, onClose, pin, setPin, password, setPassword }) => {
const token = localStorage.getItem('token')
  const handleSubmit = async () => {
    if (pin.length !== 4 || isNaN(pin)) {
      Swal.fire({
        icon: 'error',
        text: 'PIN must be exactly 4 digits',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
  
    if (!password) {
      Swal.fire({
        icon: 'error',
        text: 'Password is required!',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
  
    try {
      const response = await apiClient.post(
        `${SERVER_BASE}/update-pin`,
        {
          email: localStorage.getItem('email'),
          password,
          pin,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // attach token
          },
        }
      );
      
  
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          text: 'PIN updated successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        }).then(()=>{
          localStorage.setItem('pin', pin);
          setPassword('')
          setPin('')
          onClose();

        });
      } else {
        Swal.fire({
          icon: 'error',
          text: response.data.message || 'Update failed',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        text: err.response?.data?.message || 'Server error',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };
  

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-dark">Change PIN</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <label htmlFor="">Enter New Pin:</label>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Enter new 4-digit PIN"
              maxLength={4}
              value={pin}
              onChange={(e) => setPin(e.target.value)}
            />
             <label htmlFor="">Enter Current Password:</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter current password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="modal-footer">
            <button className="btn btn-success" onClick={handleSubmit}>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePinModal;
